<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue"><img :src="userInfo.avatar" /></div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1">{{ userInfo.nickname }}</div>
            <!-- <div class="member acea-row row-middle">
               {{ userInfo.level }}
            </div> -->
          </div>
          <!-- <router-link :to="'/user/data'" class="id" v-if="userInfo.phone">
            ID：{{ userInfo.uid || 0
            }}<span class="iconfont icon-bianji1"></span>
          </router-link> -->
          <!-- <router-link :to="'/user/binding'" class="binding" v-else>
            <span>绑定手机号</span>
          </router-link> -->
          <!-- <router-link :to="'/user/binding'" class="binding" v-else>
            <span>{{userInfo.level}}</span>
          </router-link> -->
        </div>
      </div>
      <!-- <span
        class="iconfont icon-shezhi"
        @click="$router.push({ path: '/user/data' })"
      ></span> -->
    </div>
    <div class="wrapper">
      <div class="nav acea-row row-middle">
        <router-link :to="{ path: '/user/account' }" class="item">
          <div>功德证书</div>
          <div class="num">{{ userInfo.nowMoney || 0 }}</div>
        </router-link>
        <router-link :to="{ path: '/user/account' }" class="item">
          <div>累计供灯金额</div>
          <div class="num">{{ userInfo.nowMoney || 0 }}</div>
        </router-link>
        <router-link
          :to="'/user/order/1'"
          class="item">
          <div>我的供灯</div>
          <div class="num">{{ userInfo.brokeragePrice || 0 }}</div>
        </router-link>
        <!-- <router-link
          :to="'/user/user_promotion'"
          class="item"
          v-if="userInfo.isPromoter === 1 || userInfo.statu === 2"
        >
          <div>我的供灯</div>
          <div class="num">{{ userInfo.brokeragePrice || 0 }}</div>
        </router-link> -->
        <!-- <router-link :to="'/user/integral'" class="item" v-else>
          <div>当前积分</div>
          <div class="num">{{ userInfo.integral || 0 }}</div>
        </router-link>
        <router-link :to="'/user/user_coupon'" class="item">
          <div>优惠券</div>
          <div class="num">{{ userInfo.couponCount || 0 }}</div>
        </router-link> -->
      </div>
      <!-- <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>祈福记录</div>
          <router-link :to="'/order/list/'" class="allOrder">
            全部记录<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unpaidCount > 0"
                >{{ orderStatusNum.unpaidCount }}</span
              >
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unshippedCount > 0"
                >{{ orderStatusNum.unshippedCount }}</span
              >
            </div>
            <div>待发货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.receivedCount > 0"
                >{{ orderStatusNum.receivedCount }}</span
              >
            </div>
            <div>待收货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluatedCount > 0"
                >{{ orderStatusNum.evaluatedCount }}</span
              >
            </div>
            <div>待评价</div>
          </router-link>
          <router-link :to="'/order/refund_list'" class="item">
            <div class="pictrue">
              <img src="@assets/images/sh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.refundCount > 0"
                >{{ orderStatusNum.refundCount }}</span
              >
            </div>
            <div>售后/退款</div>
          </router-link>
        </div>
      </div> -->
      <div class="myService">
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <cell :title="item.name" is-link :icon="item.pic" @click="goPages(index)"/>
          </template>
          <cell title="商户管理中心" is-link  @click="goMerchantPages()" v-if="userInfo.adminid!=0"/>
        </div>
      </div>
    </div>

    <p style="text-align: center;margin-top: 0.2rem;height: 0.3rem">南豹科技提供技术支持</p>
    <p style="text-align: center;margin-top: 0.11rem;height: 0.3rem">设备销售电话：<a style="color:red" :href="'tel:' + 19959876886">19959876886</a></p>
    <div class="footer-line-height"></div>
  </div>
</template>
<script>
import { getUserInfo, getMenuUser } from "@api/user";
import { isWeixin } from "@utils";
import { Cell } from "vant";

const NAME = "User";

export default {
  name: NAME,
  components: {
    Cell
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function() {
    this.User();
    this.MenuUser();
    this.isWeixin = isWeixin();
  },
  methods: {
    goMerchantPages(){
      this.$router.push({ path: '/user/merchant' });
    },
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUserInfo().then(res => {
        that.userInfo = res.data;
        
        // if(that.userInfo.level==0){
        //     that.userInfo.level="";
        // }else if(that.userInfo.level==4){
        //     that.userInfo.level="白银会员";
        // }else if(that.userInfo.level==5){
        //     that.userInfo.level="黄金会员";
        // }
        // that.orderStatusNum = res.data.orderStatusNum;
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].url;
      //console.log('user:'+this.userInfo.statu)
      if (url === "/user/user_promotion" && this.userInfo.statu === 1) {
        if (!this.userInfo.isPromoter)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      }

      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是管理员！！" });
      }

      if (url === "/order/order_cancellation" && !this.userInfo.checkStatus) {
        return this.$dialog.toast({ mes: "您没有核销权限,请后台店员设置！！" });
      }

      this.$router.push({ path: this.MyMenus[index].url });
    }
  }
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #eb3729;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #eb3729;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
</style>
